import styled from 'styled-components';

const typeRadio = () => ({ type: 'radio' });

export const Label = styled.label`
    position: relative;
    margin-bottom: 7px;
    margin-right: 15px;
    opacity: ${({ isActive }) => (isActive ? '1' : '0.5')};
    display: ${({ type }) => type === 'inline' && 'inline-block'};
`;

const RadioInp = styled.input.attrs(typeRadio)`
    margin: 0;
    width: 18px;
    height: 18px;
    appearance: none;
    margin-right: 10px;

    &:checked:after {
        opacity: 1;
        visibility: visible;
    }

    &:before {
        left: 0;
        top: 2px;
        content: '';
        width: 16px;
        height: 16px;
        position: absolute;
        border-radius: 16px;
        display: inline-block;
        border: 2px solid #0062ff;
    }

    &:after {
        top: 7px;
        left: 5px;
        content: '';
        width: 10px;
        height: 10px;
        opacity: none;
        visibility: hidden;
        position: absolute;
        border-radius: 10px;
        background: #0062ff;
        display: inline-block;
    }
`;

export default RadioInp;
